/**
 * Template seguro: tudo que é interpolado é escapado, exceto o que vier em raw().
 *
 *   el.innerHTML = html`<h1>Olá, ${user.name}</h1>`;       // nome escapado
 *   el.innerHTML = html`<ul>${raw(items.join(''))}</ul>`;   // HTML já montado com html``
 */

const ENTITIES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
const RAW = Symbol('raw');

export function escapeHtml(value) {
  return String(value ?? '').replace(/[&<>"']/g, (c) => ENTITIES[c]);
}

/** Marca um trecho como HTML confiável (não escapa). */
export function raw(value) {
  return { [RAW]: true, value: String(value) };
}

function render(value) {
  if (value && value[RAW]) return value.value;
  if (Array.isArray(value)) return value.map(render).join('');
  if (value === false || value === null || value === undefined) return '';
  return escapeHtml(value);
}

export function html(strings, ...values) {
  let out = '';
  strings.forEach((s, i) => {
    out += s;
    if (i < values.length) out += render(values[i]);
  });
  return raw(out);
}

/** Converte o resultado de html`` em string para innerHTML. */
export const toString = (tpl) => (tpl && tpl[RAW] ? tpl.value : escapeHtml(tpl));
